import React, {memo ,useState,useEffect} from 'react';
import {Link} from 'react-router-dom';
import Header from './Header';
import intro from './asset/image/intro.mp4'
import {ResGet,url} from './component/resapi'
import imagesLoead from './component/utility/imageLoad'
import {connect} from 'react-redux';
import {isLoading,isLoadingIntro} from "./redux/actions"
import Div100vh from 'react-div-100vh'
const Home =({isLoading,isLoadingIntro})=>{
  const [intro, setIntro] = useState(true)
  const [data, setData] = useState([])
  const [loading, setLoading] = useState(true)
  const [slideCount, setSlideCount] = useState(0)
  const [isPause, setisPause] = useState(false)
  useEffect(() => {
    isLoading(false)
    if(sessionStorage.getItem("intro")===null){
      isLoadingIntro(false)
      isLoading(true)
      setTimeout(() => {
        ResGet("gethome").then(response=>{
          if(response.status===200){
            setData(response.data)
            setLoading(false)
            setIntro(false)
            sessionStorage.setItem("intro", true);
            isLoadingIntro(true)
          }
        })
      }, 7600);
    } 
    else  {
      setIntro(false)
      ResGet("gethome").then(response=>{
        if(response.status===200){
          setData(response.data)
          setLoading(false)
          setTimeout(() => {
            imagesLoead(()=>{
              isLoading(true)
            })
          }, 1000);
        }
      })
    }
  },[])
  useEffect(() => {
    let interval;
    if(!loading){
      clearInterval(interval)
      interval = setInterval(autoSlide, 4500)
    }
    return () => clearInterval(interval);

  }, [loading,slideCount,isPause,data])

  const autoSlide=()=>{
    if(!isPause){
      if(slideCount===(data.length-1)){
        setSlideCount(0)
      }
      else {
        setSlideCount(value=>value+1)
      }
    }
    return;
  }

  const handelSetSlideleft=()=>{
    if(slideCount!==0) setSlideCount(value=>value-1)
    else setSlideCount(data.length-1)
  }
  const handelSetSlideRight=()=>{
    if(slideCount!==data.length-1) setSlideCount(value=>value+1) 
    else setSlideCount(0)
  }

  if(!intro){
  return (
    <Div100vh style={{height:"100rvh",overflow:"hidden"}}>
    <Header/>
    <div className="bg-fixed-light">
        <div className="slider">
          <div className="box" id="slider_home_box" onMouseLeave={()=>setisPause(false)} onMouseEnter={()=>setisPause(true)}>
                {!loading?data.map((data,key)=>
                  <Card key={key} data={data} show={key===slideCount}/>
                ):""}
              <div className="arrow">
                  <span className="clickable morphr" onClick={()=>handelSetSlideleft()}></span>
                  <span className="clickable morphl" onClick={()=>handelSetSlideRight()}></span>
              </div>
              <div className="circle">
                {data.map((data,key)=>
                <span key={key} className={slideCount===key?"active clickable_S":"clickable_S"} onClick={()=>setSlideCount(key)}></span>
                )}
              </div>

              
          </div>
        </div>
        <div className="home-menu">
            <Link className="hoverline clickable" to="/" style={{color:"rgba(0,0,0,1)"}}>Home</Link>  
            <Link className="hoverline clickable" to="/work">Work</Link>  
            <Link className="hoverline clickable" to="/archive">Archive</Link>  
            <Link className="hoverline clickable" to="/about">About</Link>  
            <Link className="hoverline clickable" to="/contact">Contact</Link>  
        </div>
    </div>
    </Div100vh>
  )}

  else {
    return <Introoo/>
  }

}

const Introoo = ()=>{
  return (
   <div className="intro">
    <video autoPlay={true} loop={true} muted={true} preload="metadata" playsInline={true}>
      <source src={intro} type="video/mp4"/>
    </video>
  </div>
  )
}

const Card =memo(props=>{
  return(
    <div className={`box-main ${props.show? "active":""}`}>
    <div className="image" >
      <img src={url+"/"+props.data.preview} alt={`slide-${props.data.title}`} />
    </div>
    <div className="text clickable">
      <a href={props.data.link} target="_blank" rel="noopener noreferrer" title={props.data.title}>
      <h4>{props.data.title}</h4>
      <p>{props.data.text}</p>
      </a>
    </div>
    </div>
  )
})
export default connect(null,{isLoading,isLoadingIntro})(Home);
